import type { CustomAttributeV2Fragment } from '~~/lib/Shop/generated/schema';

export type CustomAttributeV2_AttributeValue_Fragment = {
  __typename: 'AttributeValue';
  value: string;
  code: string;
  attribute_type: string | null;
  label: string;
};

export function isAttributeValue(
  p: CustomAttributeV2Fragment | undefined
): p is CustomAttributeV2_AttributeValue_Fragment {
  return Boolean(
    p &&
    typeof p === 'object' &&
    'value' in p &&
    typeof (p as { value?: unknown }).value === 'string'
  );
}
